import React from 'react';
import {createContext, useState} from 'react';
export const Context = createContext();

export const ContextProvider = ({children}) => {
	const [contextState, setContextState] = useState();	
	const formContextValues = {    	
		contextState,
		setContextState	
	}; 	

	return (<>
		<Context.Provider value={formContextValues}>
			{children}
		</Context.Provider>
	</>);
}